<template>
  <div style="margin-top: 30px">
    <div class="container">
      <img loading="lazy" :src="portfolio.image_url" class="img-main-dekstop" />
      <h2 class="title-b1">
        {{ portfolio.program }}
      </h2>

      <div class="mt-5 info-head">
        <div>
          <p class="client">
            Client
          </p>
          <p class="client-val">
            {{ portfolio.title }}
          </p>
        </div>
        <div>
          <p class="timline">
            Timeline
          </p>
          <p class="timeline-val">
            {{ $utils.getDate(portfolio.start_date, 'YYYY') }}
          </p>
        </div>
        <div>
          <p class="device">
            Device
          </p>
          <p class="device-val">
            {{portfolio.device.map(item => item.name).join(", ")}}
          </p>
        </div>
        <div>
          <p class="link">
            Link
          </p>
          <p class="link-val" @click="toRedirect(portfolio.link_project, portfolio.program)">{{ portfolio.link_project }}</p>
        </div>
      </div>
      <div>
        <h2 class="detail-proyek" v-if="portfolio.body">
          {{ $t('portfolioDetail1') }}
        </h2>
        <div class="text-justify" v-html="portfolio.body"></div>
      </div>

      <div v-if="portfolio.responsibility">
        <h2 class="responbility">{{ $t('portfolioDetail2') }}</h2>
        <div class="text-justify" v-html="portfolio.responsibility"></div>
      </div>
      <div class="tech" v-if="portfolio.technology.length">
        <h2 class="linkup-proyek">{{ $t('portfolioDetail4') }}</h2>
        <div style="display: flex; gap: 10px; overflow-x: auto;">
          <div class="mt-5 tech-ctn" v-for="(item, idx) in portfolio.technology" :key="idx">
            <div class="cont">
              <img loading="lazy" :src="item.value" :alt="`Gambar teknologi ${idx + 1}`" />
            </div>
            <p class="bb">
              {{ item.name }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="portfolio.key_feature.length">
        <h2 class="dokumentasi">{{ $t('portfolioDetail5') }}</h2>
        <img v-for="(item, idx) in portfolio.key_feature" :key="idx" loading="lazy" class="img-main-dekstop"
          :src="item.img" :alt="`Gambar dokumentasi ${idx + 1}`" />
      </div>
    </div>
    <v-card style="margin-top: 80px" elevation="0" class="call-center-container">
      <v-row style="padding: 20px 8px">
        <v-col cols="12">
          <div class="call-center-title">
            {{ $t('portfolioHelpTitle') }}
          </div>
          <div class="call-center-desc">
            {{ $t('portfolioHelpDescription') }}
          </div>
        </v-col>
        <v-col cols="12" class="call-center-button" @click="sendWa">
          <v-btn class="btn" elevation="0"> {{ $t('portfolioAct') }} </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MobilePortfolioDetail",
  components: {},
  data() {
    return {
      portfolio: {
        image_url: "",
        title: "",
        label: "",
        body: "",
        program: "",
        category: "SERVICES",
        start_date: "",
        responsibility: "",
        link_project: "",
        scope_project: [],
        key_feature: [],
        technology: [],
        device: [],
        created_at: ""
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getPortfolioDetail();
    },
  },
  methods: {
    sendWa() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Redirect to WhatsApp - Mobile Portfolio Detail Page',
        value: 1,
      });
      window.open("https://wa.me/6281234567890", "_blank");
    },
    toRedirect(link, program) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `View Project Link - ${program} - Mobile Portfolio Detail Page`,
        value: 1,
      });
      window.open(link, "_blank");
    },
    async getPortfolioDetail() {
      try {
        const resp = await this.$http.get(
          `/v1/project-portfolio/${this.$route.params.id}`
        );
        const obj = resp.data.data.project_portfolio
        this.portfolio = {
          ...obj,
          scope_project: obj.scope_project || [],
          key_feature: obj.key_feature || [],
          technology: obj.technology || [],
          device: obj.device || [],
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.getPortfolioDetail();
    this.$gtag.pageview(this.$route);
  },
};
</script>
<style scoped src="./detail.css"></style>